"use client";

import type { Menu } from "@packages/sdk";
import { usePathMatch } from "@packages/sdk";
import { Footer as FooterComponent, MinimalFooter } from "@packages/ui/emotion";
import type { HTMLAttributes } from "react";

type FooterProps = Omit<HTMLAttributes<HTMLDivElement>, "children"> & {
  menu?: Menu;
};

const MINIMAL_FOOTER_ROUTES = [
  "/upgrade/subscribe",
  "/web/subscribe",
  "/upgrade/checkout",
];

export const Footer = ({ menu, ...props }: FooterProps) => {
  const matcher = usePathMatch();
  const isMinimalFooter = MINIMAL_FOOTER_ROUTES.some((route) => matcher(route));
  if (isMinimalFooter) return <MinimalFooter {...props} />;
  return <FooterComponent menu={menu} {...props} />;
};
